
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v/[venue]/events",
      function () {
        return require("private-next-pages/v/[venue]/events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v/[venue]/events"])
      });
    }
  